var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeSliderDateContainer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 78,
  height: 28,
  viewBox: "0 0 78 28"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "642ehahxra",
  width: "120%",
  height: "170%",
  x: "-10%",
  y: "-25%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "a3zuoys02b",
  d: "M60 0c5.523 0 10 4.477 10 10s-4.477 10-10 10H0v-.999C1.884 16.494 3 13.377 3 10S1.884 3.506 0 .999V0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3zuoys02b",
  fill: "#000",
  filter: "url(#642ehahxra)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "#177991",
  strokeLinejoin: "square",
  d: "M60 .5a9.47 9.47 0 0 1 6.718 2.782A9.47 9.47 0 0 1 69.5 10a9.47 9.47 0 0 1-2.782 6.718A9.47 9.47 0 0 1 60 19.5H.5c1.886-2.9 3-6.07 3-9.5S2.386 3.4.5.834z"
}))));
export default SvgTimeSliderDateContainer;